﻿/**
 * portal-app-logo.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-app-logo.controller', portalAppLogoController);

	/** setup injection */
	portalAppLogoController.$inject = ['portal-link.repository'];

	/** implementation */
	function portalAppLogoController(portalLinkRepository) {
		/** pubic properties */
		var vm = this;
		vm.loading = false;
		vm.portalLink = null;

		/** run init */
		init();

		/** private methods */

		/** initialize */
		function init() {
			/** flip loading flag */
			vm.loading = true;

			/** get the corresponding portal links */
			portalLinkRepository.getForSettingKey(vm.settingKey).then(function(portalLink) {
				/** set the portal link */
				vm.portalLink = portalLink;

				/** flip loading flag */
				vm.loading = false;
			});
		}
	}
})();